import React, { useState, useEffect } from 'react';
import { Modal, Button, Tag, Space, Carousel } from 'antd';
import { CalendarOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import api from '../utils/api';
import { festivalImage } from '../utils/festivalImages';

// Chhutti ki photo: chhutti ke dino ke festival ki apni photo, warna devta ki photo (backend title se nikalta hai).

const GRADIENTS = {
  rakhi: 'linear-gradient(135deg,#ff7a45,#f759ab)',
  krishna: 'linear-gradient(135deg,#2f54eb,#722ed1)',
  ganesh: 'linear-gradient(135deg,#fa8c16,#f5222d)',
  shiv: 'linear-gradient(135deg,#08979c,#1d39c4)',
  durga: 'linear-gradient(135deg,#f5222d,#fa8c16)',
  laxmi: 'linear-gradient(135deg,#d48806,#fa541c)',
  hanuman: 'linear-gradient(135deg,#fa541c,#faad14)',
  ram: 'linear-gradient(135deg,#faad14,#fa8c16)',
  saraswati: 'linear-gradient(135deg,#faad14,#ffec3d)',
  surya: 'linear-gradient(135deg,#fa8c16,#ffc53d)',
  holi: 'linear-gradient(135deg,#eb2f96,#13c2c2)',
  flag: 'linear-gradient(135deg,#fa8c16,#52c41a)',
  shubh: 'linear-gradient(135deg,#722ed1,#eb2f96)',
};

const fmt = (d) => dayjs(d).format('DD MMM (ddd)');
const range = (r) => (r.start_date === r.end_date ? fmt(r.start_date) : `${fmt(r.start_date)} – ${fmt(r.end_date)}`);

// Staff ke home page par chhutti khatam hone tak dikhta hai. Popup chhutti se
// ek din pehle se shuru hota hai; band karne ke baad patti dikhti rehti hai.
export default function HolidayBanner() {
  const [ranges, setRanges] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    api.get('/staff/holidays-upcoming')
      .then(r => {
        const list = Array.isArray(r.data) ? r.data : [];
        setRanges(list);
        const hot = list.find(x => x.popup);
        if (hot) {
          const key = `holiday-popup-${hot.start_date}-${dayjs().format('YYYY-MM-DD')}`;
          if (!sessionStorage.getItem(key)) {
            sessionStorage.setItem(key, '1');
            setOpen(true);
          }
        }
      })
      .catch(() => {});
  }, []);

  if (ranges.length === 0) return null;

  const hot = ranges.find(r => r.popup) || ranges[0];
  const deity = hot.deity || 'shubh';
  const grad = GRADIENTS[deity] || GRADIENTS.shubh;
  const title = (hot.titles || []).join(', ');

  return (
    <>
      <div
        onClick={() => setOpen(true)}
        style={{
          display: 'flex', alignItems: 'center', gap: 14, cursor: 'pointer', marginBottom: 16,
          padding: 12, borderRadius: 14, color: '#fff', background: grad,
          boxShadow: '0 6px 18px rgba(0,0,0,0.18)', flexWrap: 'wrap',
        }}
      >
        <img
          src={festivalImage(hot.image, deity)}
          alt={title}
          style={{ width: 64, height: 64, borderRadius: 12, objectFit: 'cover', border: '2px solid rgba(255,255,255,0.8)' }}
        />
        <div style={{ flex: 1, minWidth: 220 }}>
          <div style={{ fontSize: 18, fontWeight: 700, lineHeight: 1.2 }}>
            {hot.greeting || 'Chhutti'} {title ? `— ${title}` : ''}
          </div>
          <div style={{ fontSize: 14, opacity: 0.95, marginTop: 2 }}>
            <CalendarOutlined /> {range(hot)} · {hot.days} din ki chhutti
            {hot.ongoing ? ' · chal rahi hai' : ` · ${dayjs(hot.start_date).diff(dayjs().startOf('day'), 'day')} din baad`}
          </div>
        </div>
        <Tag color="gold" style={{ fontWeight: 600, margin: 0 }}>Dekho</Tag>
      </div>

      <Modal
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
        centered
        width={480}
        styles={{ body: { padding: 0, borderRadius: 16, overflow: 'hidden' }, content: { padding: 0, borderRadius: 16, overflow: 'hidden' } }}
      >
        <div style={{ background: grad, padding: '22px 20px', textAlign: 'center', color: '#fff' }}>
          <div style={{ fontSize: 26, fontWeight: 800, textShadow: '0 2px 6px rgba(0,0,0,0.25)' }}>
            {hot.greeting || 'Chhutti ki shubhkamnaye'}
          </div>
          {title && <div style={{ fontSize: 16, marginTop: 4, opacity: 0.95 }}>{title}</div>}
        </div>
        {(hot.images || []).length > 1 ? (
          <Carousel autoplay autoplaySpeed={3500}>
            {hot.images.map(p => (
              <div key={p.image}>
                <img src={p.image} alt={p.name} style={{ width: '100%', maxHeight: 300, objectFit: 'cover', display: 'block' }} />
                <div style={{ textAlign: 'center', fontWeight: 600, padding: '6px 0 18px' }}>{p.name} · {fmt(p.date)}</div>
              </div>
            ))}
          </Carousel>
        ) : (
          <img
            src={festivalImage(hot.image, deity)}
            alt={title}
            style={{ width: '100%', maxHeight: 300, objectFit: 'cover', display: 'block' }}
          />
        )}
        <div style={{ padding: 20, textAlign: 'center' }}>
          <div style={{ fontSize: 18, fontWeight: 700 }}>{range(hot)}</div>
          <Space size={8} style={{ marginTop: 8, flexWrap: 'wrap', justifyContent: 'center' }}>
            <Tag color="purple" style={{ fontSize: 14, padding: '2px 10px' }}>{hot.days} din ki chhutti</Tag>
            {hot.ongoing
              ? <Tag color="green" style={{ fontSize: 14, padding: '2px 10px' }}>Chhutti chal rahi hai</Tag>
              : <Tag color="blue" style={{ fontSize: 14, padding: '2px 10px' }}>
                  {dayjs(hot.start_date).diff(dayjs().startOf('day'), 'day')} din baad
                </Tag>}
          </Space>
          <div style={{ color: '#595959', marginTop: 12 }}>
            Chhutti ke din attendance apne aap Holiday rahegi — salary nahi katti.
          </div>
          <Button type="primary" size="large" style={{ marginTop: 16, borderRadius: 20, minWidth: 140 }} onClick={() => setOpen(false)}>
            Theek hai
          </Button>
        </div>
      </Modal>

      {ranges.length > 1 && (
        <div style={{ marginBottom: 16, fontSize: 13, color: '#595959' }}>
          Aage aane wali chhutti: {ranges.filter(r => r !== hot).map(r => `${range(r)} (${(r.titles || []).join(', ')})`).join(' · ')}
        </div>
      )}
    </>
  );
}
